import { toIntOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IAssessLiverHealthFormValues,
    IAssessLiverHealthModel,
    IAssessLiverHealthSubmitResult,
} from '@/types/screening/assess-liver-health';

const ASSESS_LIVER_HEALTH_ENDPOINT = '/api/register/assess-liver-health';

const defaultAssessLiverHealthModel: IAssessLiverHealthModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AssessLiverHealth,
    historyLiverDisease: null,
    hasHepB: null,
    hasHepC: null,
};

export const useAssessLiverHealth = (registrationId: number, editKey: string) => {
    const url = `${ASSESS_LIVER_HEALTH_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAssessLiverHealthModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<
        IAssessLiverHealthFormValues,
        DashRegistrationStep,
        IAssessLiverHealthSubmitResult
    >(
        url,
        (values) => ({
            historyLiverDisease: toIntOrNull(values.historyLiverDisease),
            hasHepB: toIntOrNull(values.hasHepB),
            hasHepC: toIntOrNull(values.hasHepC),
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
